'use client';

var translations = {
    Cancel: 'Hủy',
    'No result': 'Không có kết quả'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
